import { render, staticRenderFns } from "./FirstStepsAuthLayout.vue?vue&type=template&id=24415bda&scoped=true&"
import script from "./FirstStepsAuthLayout.vue?vue&type=script&lang=js&"
export * from "./FirstStepsAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepsAuthLayout.vue?vue&type=style&index=0&id=24415bda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24415bda",
  null
  
)

export default component.exports